// extracted by mini-css-extract-plugin
export var bodySections = "_6e-8";
export var gray = "_6e-7";
export var green = "_6e-4";
export var iconContainer = "_6e-9";
export var iconWidgetContainer = "_6e-1";
export var phoneIcon = "_6e-2";
export var red = "_6e-5";
export var statusDot = "_6e-3";
export var widgetContainer = "_6e-0";
export var yellow = "_6e-6";